import React, { useCallback } from "react";
import { Container, Card } from "./styles";
import Image from "../Image";
import editorFeatureStudioShot from "../../images/bluedot_studio_shot.jpg";
import editorFeatureScreenShot from "../../images/stemeditor_screenshot.jpg";
import { Link } from "gatsby";
import gql from "graphql-tag";
import { useLazyQuery } from "react-apollo";

const galleryImgStyle = {
  maxWidth: "100%",
  height: 240,
};

const GET_EDITOR_DEMOS = gql`
  {
    demoTracks {
      id
    }
  }
`;

const AboutUs = () => {
  // get a list of demo tracks we could load up
  const [getDemoTrackIds, resDemoTracks] = useLazyQuery(GET_EDITOR_DEMOS, {
    onCompleted: (res) => {
      spawnEditorDemo();
    },
  });

  const spawnEditorDemo = useCallback(() => {
    if (!resDemoTracks.data) return;
    if (resDemoTracks.data.demoTracks.length > 0) {
      const demoTrackId =
        resDemoTracks.data.demoTracks[
          Math.floor(Math.random() * resDemoTracks.data.demoTracks.length)
        ].id;
      window.location = `${process.env.GATSBY_BLUE_DOT_APP_URL}/browse/track/${demoTrackId}?spawnEditor=true&trackId=${demoTrackId}&demo=true`;
    }
  }, [resDemoTracks.data]);

  return (
    <Container>
      <div className="mobile">
        <Image
          className="studio-img-mobile"
          filename={`studio3`}
          style={galleryImgStyle}
        />
      </div>

      <div className="cards">
        <Card>
          <p>
            <span className="highlight purple">simple blanket licenses</span>{" "}
            that cover unlimited tracks for your project
          </p>
        </Card>
        <Card>
          <p>
            <span className="highlight pink">professionally recorded</span> to
            work alongside narration for video, podcasting and the web
          </p>
        </Card>
        <Card>
          <p>
            Make your own mix from our{" "}
            <span className="highlight blue">multitrack stem files</span>
          </p>
        </Card>
      </div>

      <div className="desktop images">
        {[1, 2, 3, 4].map((picNumber) => (
          <Image
            key={picNumber}
            filename={`studio${picNumber}`}
            style={galleryImgStyle}
          />
        ))}
      </div>

      <div id="editor-feature" className="desktop">
        <img
          id="editor-feature-studio-shot"
          src={editorFeatureStudioShot}
          alt="studio b-roll"
        />
        <img
          id="editor-feature-screen-shot"
          src={editorFeatureScreenShot}
          alt="editor screenshot"
        />
        <div id="editor-feature-floater" className="editor-feature-cta">
          <div className="editor-feature-regions">
            <div className="region region-1">Integrated Stem Editor</div>
            <div className="region region-2"></div>
            <div className="region region-3"></div>
          </div>
          <div className="editor-feature-text">
            <div className="editor-feature-header">
              Make quick changes to tracks and download the high-quality result
            </div>
            <div className="editor-feature-body">
              Get exactly the track you need fast with tempo-sync, cross fades
              and audio effects.
            </div>
            <div className="editor-feature-funnel">
              <button
                className="btn-editor-demo"
                onClick={() => {
                  if (!resDemoTracks.called) getDemoTrackIds();
                  if (resDemoTracks.data) {
                    spawnEditorDemo();
                  }
                }}
              >
                Demo The Editor Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AboutUs;
